import {CrossButtonBlack} from "components/Buttons/CrossButton";
import clsx from "clsx";
import {Button} from "@material-ui/core";
import React from "react";
import styles from "./components.module.scss";

export const RemoveContactInfoModal = ({onCloseButtonClick}: { onCloseButtonClick: (e: any) => void }) => {
    return (
        <>
            <div className={styles.titleContainer}>
                <div className={styles.popupTitle}>
                    Why does TempStars remove contact information?
                </div>
                <CrossButtonBlack
                    className={clsx("no-fastclick", styles.crossButtonDark)}
                    onClick={onCloseButtonClick}
                />
            </div>
            <div className={styles.description}>
                We want to ensure the connections and communications you make through TempStars are as safe and relevant to you as possible.
                <br/><br/>
                So we remove contact information, but don't worry!  We have an in-app chat system and other ways you can communicate with dental offices.
            </div>
            <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={onCloseButtonClick}
                className={clsx("bigButtonInNewStyle")}
            >
                OK
            </Button>
        </>
    );
}